// @charset "utf-8";
/*
 * 点击元素外面触发事件
 * e.g. <input
            ref="question_cycle_input"
            v-validate="{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice'}"
            >

        <input
            ref="question_sentence_input"
            v-validate="{ type: 'string', max: 200, min: 1, errClass: 'question_sentence_input focus', errRef: 'sentenceNotice'}"
            >
 *
 */

import { numberDays, questionVal, profitLossVal } from '@/lib/formValidation.js'

var nodeList = []

var ctx = 'vue_validate' // 同命名空间的意思

export default {
    bind (el, binding, vnode) {
        let id = nodeList.push(el) - 1
        let validateData = binding.value
        el.oldClassName = el.className
        el[ctx] = {id: id}
        // 保证只验证当前el
        el.validate = () => {
            nodeList.forEach((node) => {
                if (node[ctx].id !== el[ctx].id) {
                    node.validateHandle(true)
                }
            })
            return el.validateHandle()
        }
        el.validateHandle = (skipValidate) => {
            if (skipValidate) {
                el.successHandle()
                return true
            }
            let type = validateData.type
            let value = el.value ? el.value : (el.text ? el.text : '')
            let ret
            switch (type) {
            case 'string': // 字符验证
                ret = questionVal(value, validateData.max, validateData.min)
                break

            case 'number':
                ret = profitLossVal(value)
                break

            case 'period': // 持股周期
                ret = numberDays(value, validateData.isGt1)
                break

            case 'default':
                break
            }
            if (ret) {
                el.successHandle()
                return true
            } else {
                el.failHandle()
                return false
            }
        }

        el.successHandle = () => {
            el.className = el.oldClassName

            if (validateData.errRef !== undefined) {
                vnode.context.$refs[validateData.errRef].style.display = 'none'
            }
        }

        el.failHandle = () => {
            el.focus()
            // 错误时样式
            if (validateData.errClass !== undefined) {
                el.className = validateData.errClass
            }

            // 错误时其他dom控制显隐
            if (validateData.errRef !== undefined) {
                vnode.context.$refs[validateData.errRef].style.display = 'block'
            }
        }
    },
    update (el, binding) {
    },
    unbind (el) {
        var len = nodeList.length

        for (var i = 0; i < len; i++) {
            if (nodeList[i][ctx].id === el[ctx].id) {
                nodeList.splice(i, 1)
                break
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/dataValidation.js